var _effectorFileName = "/src/page-content/teachers/components/about-teachers/about-teachers.tsx";
import { useTranslation } from 'next-i18next';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import ThunderstormIcon from '@/shared/components/icons/thunderstorm-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { TeachersImages } from './teachers-images';
const ALL_TEACHERS_ITEMS = ['allTeachers.items.0', 'allTeachers.items.1', 'allTeachers.items.2', 'allTeachers.items.3'];
export const AboutTeachers = () => {
  const {
    t
  } = useTranslation('teachers-about');
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(200px,_35%)] sm:gap-x-10 md:grid-cols-2">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5">
            <TextGradient text={t('title')} tag="h1" className="mb-3 text-center text-5xl sm:mb-4 sm:max-w-lg sm:text-left" />

            <p className="mx-auto max-w-xs pl-6 text-sm xss:max-w-md xss:text-base xs:pl-0 sm:mx-0 sm:max-w-xl" dangerouslySetInnerHTML={{
            __html: t('description')
          }} />
          </div>

          <div className="mb-8">
            <h2 className="mb-4 text-center header-h2 sm:text-left sm:header-h3">{t('allTeachers.title')}</h2>

            <ul className="mx-auto max-w-sm space-y-2 sm:mx-0 sm:max-w-xl">
              {ALL_TEACHERS_ITEMS.map((itemKey, index) => <li key={index} className="flex items-center gap-2">
                  <ThunderstormIcon className="mr-2 h-6 w-6 shrink-0 text-brand-accent-light sm:mr-4" />
                  <span dangerouslySetInnerHTML={{
                __html: t(itemKey)
              }} />
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center sm:block">
            <ContactModal entryPoint="TEACHERS_PAGE">
              <Button variant="cta" className="px-6" aria-label={t('ctaAria')}>
                {t('cta')}
              </Button>
            </ContactModal>
          </div>
        </div>

        <TeachersImages />
      </div>
    </Article>;
};